var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "los-classification" }, [
    !_vm.dataLoaded ? _c("div", [_vm._v(_vm._s(_vm.$t("loading")))]) : _vm._e(),
    _c(
      "div",
      {
        directives: [
          {
            name: "click-outside",
            rawName: "v-click-outside",
            value: () => (_vm.expand = false),
            expression: "() => expand=false",
          },
        ],
        staticClass: "card mr-1 ml-1 pl-1 pt-1 pr-1 pb-1",
      },
      [
        _c("div", { staticClass: "flex-row flex-1 header" }, [
          _c("div", { staticClass: "flex-col" }, [
            _c(
              "div",
              { staticClass: "comment-icon" },
              [
                _c("font-awesome-icon", {
                  attrs: { icon: ["fas", "text-width"] },
                }),
              ],
              1
            ),
          ]),
          _c(
            "div",
            {
              staticClass:
                "flex-col flex-3 flex-justify-center ml-4 mr-5 pr-4 pl-2",
              attrs: { id: "category" },
            },
            [_vm._v(" " + _vm._s(_vm.losData.category) + " ")]
          ),
          _c("span", { staticClass: "separator ml-6 mr-4" }),
          _c(
            "div",
            {
              staticClass: "flex-col flex-justify-center flex-3",
              attrs: { id: "classification" },
            },
            [_vm._v(" " + _vm._s(_vm.losData.classification) + " ")]
          ),
          _c("span", { staticClass: "separator ml-4 mr-4" }),
          _c(
            "div",
            {
              staticClass: "flex-col flex-justify-center flex-1 pr-2",
              staticStyle: { "align-items": "flex-end" },
            },
            [
              _c(
                "div",
                {
                  staticClass: "flex-row expand",
                  on: {
                    click: function ($event) {
                      _vm.expand = !_vm.expand
                    },
                  },
                },
                [
                  _c("div", { staticClass: "flex-col mr-1" }, [
                    _vm._v(_vm._s(_vm.expand ? "COLLAPSE" : "EXPAND")),
                  ]),
                  _c("font-awesome-icon", {
                    staticClass: "flex-col",
                    attrs: {
                      icon: ["fas", _vm.expand ? "angle-up" : "angle-down"],
                    },
                  }),
                ],
                1
              ),
            ]
          ),
        ]),
        _c("span", {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.expand,
              expression: "expand",
            },
          ],
          staticClass: "flex-row flex-1 line-separator",
        }),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.expand,
                expression: "expand",
              },
            ],
            staticClass: "flex-row flex-1",
          },
          [
            _c(
              "div",
              { staticClass: "flex-col los-value", attrs: { id: "value" } },
              [_c("p", [_vm._v(_vm._s(_vm.losData.value))])]
            ),
          ]
        ),
        _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.expand,
                expression: "expand",
              },
            ],
            staticClass: "flex-row reverse pr-2",
          },
          [
            _vm.hasLosEditAccess
              ? _c(
                  "div",
                  { staticClass: "flex-col flex-align-end" },
                  [
                    _c(
                      "adam-button",
                      {
                        attrs: { secondary: "", icon: "ic-latest-edits" },
                        on: { click: _vm.edit },
                      },
                      [_vm._v("Edit")]
                    ),
                  ],
                  1
                )
              : _vm._e(),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }